'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useRestoreFocusSource: function() {
        return useRestoreFocusSource;
    },
    useRestoreFocusTarget: function() {
        return useRestoreFocusTarget;
    }
});
const _tabster = require("tabster");
const _useTabster = require("./useTabster");
function useRestoreFocusTarget() {
    // Initializes the restorer API
    (0, _useTabster.useTabster)(_tabster.getRestorer);
    return (0, _tabster.getTabsterAttribute)({
        restorer: {
            type: _tabster.RestorerTypes.Target
        }
    });
}
function useRestoreFocusSource() {
    // Initializes the restorer API
    (0, _useTabster.useTabster)(_tabster.getRestorer);
    return (0, _tabster.getTabsterAttribute)({
        restorer: {
            type: _tabster.RestorerTypes.Source
        }
    });
}
